import { Routes } from '@angular/router';
import { anonymousOnlyGuard } from './auth/anonymous-only.guard';
import { operatorAuthGuard } from './auth/operator-auth.guard';

export const routes: Routes = [
  {
    path: 'login',
    canActivate: [anonymousOnlyGuard],
    loadComponent: () => import('./auth/login-page.component').then((module) => module.LoginPageComponent),
  },
  {
    path: '',
    canActivate: [operatorAuthGuard],
    loadComponent: () =>
      import('./features/dashboard-shell/dashboard-shell.component').then((module) => module.DashboardShellComponent),
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'dashboard',
      },
      {
        path: 'dashboard',
        loadComponent: () =>
          import('./features/operator-home/operator-home.component').then((module) => module.OperatorHomeComponent),
      },
      {
        path: 'workers',
        loadComponent: () =>
          import('./features/operator-home/operator-home.component').then((module) => module.OperatorHomeComponent),
      },
      {
        path: 'pools',
        loadComponent: () => import('./features/pools/pools.component').then((module) => module.PoolsComponent),
      },
      {
        path: 'pools/:poolId',
        loadComponent: () =>
          import('./features/pool-detail/pool-detail.component').then((module) => module.PoolDetailComponent),
      },
      {
        path: 'settings',
        loadComponent: () =>
          import('./features/operator-home/operator-home.component').then((module) => module.OperatorHomeComponent),
      },
    ],
  },
  {
    path: '**',
    redirectTo: 'dashboard',
  },
];
